function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#202124",
  fillRule: "nonzero",
  stroke: "#202124"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M15.571 8H8.357V6.143C8.357 4.714 9.5 3.5 11 3.5h.929c1.071 0 2 .643 2.428 1.571.143.358.572.5.929.358.357-.143.5-.572.357-.929C15 3 13.57 2 11.929 2H11C8.786 2 6.929 3.786 6.929 6.071V8C5.286 8.286 4 9.786 4 11.5v7.929C4 21.429 5.571 23 7.571 23H15.5c2 0 3.571-1.571 3.571-3.571V11.57c.072-2-1.571-3.571-3.5-3.571zm2.143 11.5c0 1.214-.928 2.143-2.143 2.143h-8c-1.214 0-2.142-.929-2.142-2.143v-7.929c0-1.214.928-2.142 2.142-2.142H15.5c1.214 0 2.143.928 2.143 2.142V19.5h.071zm-5.071-5.143c0 .286-.143.572-.357.786v1.643c0 .428-.286.714-.715.714-.428 0-.714-.286-.714-.714v-1.643c-.214-.214-.357-.5-.357-.786 0-.571.5-1.071 1.071-1.071.572 0 1.072.5 1.072 1.071z",
  transform: "translate(-120 -443) translate(120 443)"
}))));

var SvgIconPassword = function SvgIconPassword(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPassword, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-password.92717554.svg";
export { ForwardRef as ReactComponent };